import { Workbox } from "workbox-window";

/**
 * Registra el Service Worker en producción. No-op en dev (devOptions.enabled=false).
 * Detecta updates y puede prompt al usuario para refrescar.
 */
export function registerSW(): void {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (!import.meta.env.PROD) return;

  const wb = new Workbox("/sw.js", { type: "module" });

  wb.addEventListener("waiting", () => {
    // Nueva versión esperando. Auto-activa tras un pequeño delay.
    // Para UX avanzada (toast "recargar"), sustituir por prompt manual.
    void wb.messageSkipWaiting();
  });

  wb.addEventListener("controlling", () => {
    // Recarga para tomar la nueva versión del SW una vez controla la página.
    window.location.reload();
  });

  wb.register().catch((err) => {
    // eslint-disable-next-line no-console
    console.warn("SW registration failed:", err);
  });
}
